import { toRelativeUrl } from '@okta/okta-auth-js';
import { useOktaAuth } from '@okta/okta-react';
import React, { Suspense, useEffect } from 'react';
import { Outlet } from 'react-router-dom';

import { AppLayout } from '../components/layouts';
import { Loading } from '../components/progress';
import { AuthDataProvider } from '../contexts';

const SecureRoute: React.FC = () => {
  const { oktaAuth, authState } = useOktaAuth();

  useEffect(() => {
    if (!authState) {
      return;
    }
    if (!authState?.isAuthenticated) {
      let signinTimeOut = setTimeout(() => {
        const originalUri = toRelativeUrl(
          window.location.href,
          window.location.origin
        );
        oktaAuth.setOriginalUri(originalUri);
        oktaAuth.signInWithRedirect();
      }, 1000);
      return () => {
        clearTimeout(signinTimeOut);
      };
    }
  }, [authState, oktaAuth]);

  if (!authState || !authState?.isAuthenticated) {
    return <Loading />;
  }

  return (
    <AuthDataProvider>
      <AppLayout>
        <Suspense fallback={<Loading />}>
          <Outlet />
        </Suspense>
      </AppLayout>
    </AuthDataProvider>
  );
};

export default SecureRoute;
